module.exports = __webpack_public_path__ + "img/scheduler_icon.8b201b88.svg";